import moment from "moment";
import { PRE_AUTH_LOCAL_STORAGE_KEYS } from "../../../const/preAuthConsts";
import { promptZoomForUncommonScreenSizes } from "./promptZoomForUncommonScreenSizes";
import { MIN_RECOMMENDED_WIDTH, MAX_RECOMMENDED_WIDTH, SCREEN_SIZE_MAX_PROMPTS } from "./screenResolutionConsts";

/**
 * limits the number of times the prompt is displayed based on localStorage
 * */
export function promptZoomForNewScreenSize(screen: { width: number } = window.screen) {
    const screenWidth = screen && screen.width;
    if (!screenWidth || (screenWidth >= MIN_RECOMMENDED_WIDTH && screenWidth <= MAX_RECOMMENDED_WIDTH)) return;

    const pastPrompts = localStorage.getItem(PRE_AUTH_LOCAL_STORAGE_KEYS.screenResolutionPrompt) || "0 0 0";
    const [pastCount, pastWidth, timeStamp] = pastPrompts.split(" ").map(Number);
    if (pastCount >= SCREEN_SIZE_MAX_PROMPTS && screenWidth == pastWidth) return;

    const now = Date.now();
    if (timeStamp && moment(timeStamp).isSame(now, "day") && screenWidth == pastWidth) return;

    promptZoomForUncommonScreenSizes(screenWidth);
    localStorage.setItem(PRE_AUTH_LOCAL_STORAGE_KEYS.screenResolutionPrompt, `${pastCount + 1} ${screenWidth} ${now}`);
}
